module.exports = __webpack_public_path__ + "img/facebook-white.579e04f4.svg";